import React from 'react';
import {
	Card,
	CardContent,
	Typography,
	Grid,
	Chip,
	makeStyles
} from '@material-ui/core';
import { format } from 'date-fns';

const useStyles = makeStyles((theme) => ({
	card: {
		marginBottom: theme.spacing(2),
	},
	metricItem: {
		textAlign: 'center',
		padding: theme.spacing(1),
	},
	metricValue: {
		fontSize: '1.5rem',
		fontWeight: 'bold',
		color: theme.palette.primary.main,
	},
	metricLabel: {
		fontSize: '0.875rem',
		color: theme.palette.text.secondary,
	},
	urlChip: {
		marginTop: theme.spacing(1),
	},
}));

const WebsiteInfo = ({ website }) => {
	const classes = useStyles();

	if (!website) {
		return null;
	}

	const formatDate = (dateString) => {
		try {
			return format(new Date(dateString), 'PPpp');
		} catch (error) {
			return dateString;
		}
	};

	return (
		<Card className={classes.card}>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					Website Information
				</Typography>
				
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6} md={3}>
						<div className={classes.metricItem}>
							<Typography className={classes.metricValue}>
								{website.totalPages || 0}
							</Typography>
							<Typography className={classes.metricLabel}>
								Pages Crawled
							</Typography>
						</div>
					</Grid>
					
					<Grid item xs={12} sm={6} md={3}>
						<div className={classes.metricItem}>
							<Typography className={classes.metricValue}>
								{website.maxPagesRequested || 0}
							</Typography>
							<Typography className={classes.metricLabel}>
								Max Pages Requested
							</Typography>
						</div>
					</Grid>
					
					<Grid item xs={12} sm={6} md={3}>
						<div className={classes.metricItem}>
							<Typography className={classes.metricValue}>
								{formatDate(website.crawledAt)}
							</Typography>
							<Typography className={classes.metricLabel}>
								Crawled At
							</Typography>
						</div>
					</Grid>
					
					<Grid item xs={12} sm={6} md={3}>
						<div className={classes.metricItem}>
							<Chip
								label={website.url}
								variant="outlined"
								color="primary"
								className={classes.urlChip}
								onClick={() => window.open(website.url, '_blank')}
								style={{ cursor: 'pointer' }}
							/>
							<Typography className={classes.metricLabel}>
								Website URL
							</Typography>
						</div>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
};

export default WebsiteInfo;
